import { StatUsersType } from '../../models';

const TRENDS_URL = '/trends';

export function trendsApi() {
  return TRENDS_URL;
}

export function trendsNetsApi() {
  return `${TRENDS_URL}/nets`;
}

export function trendsNetsStatisticApi() {
  return `${TRENDS_URL}/nets/statistic`;
}

export function trendsAndroidVersions() {
  return `${TRENDS_URL}/android-versions`;
}

export function trendsStatUsersPackages(
  statUserType = StatUsersType.ActiveUsers,
) {
  return `${TRENDS_URL}/${statUserType}/packages-list`;
}

export function trendsActiveUsersAppVersions(
  statUserType = StatUsersType.ActiveUsers,
) {
  return `${TRENDS_URL}/${statUserType}/app-versions`;
}

export function trendsUsersTypeStat(statUserType = StatUsersType.ActiveUsers) {
  return `${TRENDS_URL}/${statUserType}/packages-stat`;
}

export function trendsStat5AndroidVersions() {
  return `${TRENDS_URL}/stat5/android-versions`;
}

export function trendsStat5CountriesStatistic() {
  return `${TRENDS_URL}/stat5/countries`;
}
